"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getURNProtocol = exports.getChainName = exports.ChainId = void 0;
const validation_1 = require("../validation");
const chain_name_1 = require("./chain-name");
/**
 * Different supported chain ids
 * @alpha
 */
var ChainId;
(function (ChainId) {
    ChainId[ChainId["ETHEREUM_MAINNET"] = 1] = "ETHEREUM_MAINNET";
    ChainId[ChainId["ETHEREUM_ROPSTEN"] = 3] = "ETHEREUM_ROPSTEN";
    ChainId[ChainId["ETHEREUM_RINKEBY"] = 4] = "ETHEREUM_RINKEBY";
    ChainId[ChainId["ETHEREUM_GOERLI"] = 5] = "ETHEREUM_GOERLI";
    ChainId[ChainId["ETHEREUM_KOVAN"] = 42] = "ETHEREUM_KOVAN";
    ChainId[ChainId["MATIC_MAINNET"] = 137] = "MATIC_MAINNET";
    ChainId[ChainId["MATIC_MUMBAI"] = 80001] = "MATIC_MUMBAI";
})(ChainId = exports.ChainId || (exports.ChainId = {}));
/**
 * Get the chain name by chain id
 * @alpha
 */
function getChainName(chainId) {
    switch (chainId) {
        case ChainId.ETHEREUM_MAINNET:
            return chain_name_1.ChainName.ETHEREUM_MAINNET;
        case ChainId.ETHEREUM_ROPSTEN:
            return chain_name_1.ChainName.ETHEREUM_ROPSTEN;
        case ChainId.ETHEREUM_RINKEBY:
            return chain_name_1.ChainName.ETHEREUM_RINKEBY;
        case ChainId.ETHEREUM_GOERLI:
            return chain_name_1.ChainName.ETHEREUM_GOERLI;
        case ChainId.ETHEREUM_KOVAN:
            return chain_name_1.ChainName.ETHEREUM_KOVAN;
        case ChainId.MATIC_MAINNET:
            return chain_name_1.ChainName.MATIC_MAINNET;
        case ChainId.MATIC_MUMBAI:
            return chain_name_1.ChainName.MATIC_MUMBAI;
        default:
            return null;
    }
}
exports.getChainName = getChainName;
/**
 * Get the chain name by chain id
 * @alpha
 */
function getURNProtocol(chainId) {
    switch (chainId) {
        case ChainId.ETHEREUM_MAINNET:
            return 'mainnet';
        case ChainId.ETHEREUM_ROPSTEN:
            return 'ropsten';
        case ChainId.ETHEREUM_RINKEBY:
            return 'rinkeby';
        case ChainId.ETHEREUM_GOERLI:
            return 'goerli';
        case ChainId.ETHEREUM_KOVAN:
            return 'kovan';
        case ChainId.MATIC_MAINNET:
            return 'matic';
        case ChainId.MATIC_MUMBAI:
            return 'mumbai';
    }
}
exports.getURNProtocol = getURNProtocol;
/**
 * @alpha
 */
(function (ChainId) {
    ChainId.schema = {
        type: 'number',
        enum: Object.values(ChainId)
    };
    ChainId.validate = (0, validation_1.generateValidator)(ChainId.schema);
})(ChainId = exports.ChainId || (exports.ChainId = {}));
//# sourceMappingURL=chain-id.js.map